import { ContentGroup, Grid, GridItem, Paragraph, Text, } from '@imported/constellation';
import React from 'react';
import { useLabelContext } from '../../context/LabelContext.js';
import { VerticalSpace } from '../FormFields/index.js';
import { CommonFormStyleWrapper } from '../FormFields/styles.js';
import Navigation from '../Navigation/index.js';
import { ListWrapper } from './styles.js';
const AllowPermissionCameraForm = ({ handleAllowPermissionSubmission, handlePreviousPage, }) => {
    const { getLabelFromContext } = useLabelContext();
    return (React.createElement(CommonFormStyleWrapper, null,
        React.createElement(Grid, null,
            React.createElement(GridItem, null,
                React.createElement(ContentGroup, null,
                    getLabelFromContext('components.allowPermissionForm.steps').map((el, index) => (React.createElement(ListWrapper, { key: el },
                        React.createElement(Text, null, `${index + 1}.`),
                        React.createElement(Paragraph, null, el.replace('xxxx', window.location.origin))))),
                    React.createElement(Paragraph, null, getLabelFromContext('components.allowPermissionForm.description.notCompatible')),
                    React.createElement(Paragraph, null, getLabelFromContext('components.allowPermissionForm.description.skip')),
                    React.createElement(VerticalSpace, { space: 40 }),
                    React.createElement(Navigation, { previousLabel: getLabelFromContext('components.allowPermissionForm.navigation.previous'), submitLabel: getLabelFromContext('components.allowPermissionForm.navigation.next'), handleNext: handleAllowPermissionSubmission, handlePrevious: handlePreviousPage }))))));
};
export default AllowPermissionCameraForm;
//# sourceMappingURL=index.js.map